import { render, staticRenderFns } from "./delete-positions-button.vue?vue&type=template&id=15f8c086"
import script from "./delete-positions-button.vue?vue&type=script&lang=js"
export * from "./delete-positions-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports